import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BrifingFormService } from 'src/@core/services/briefing-form/brifing-form.service';

@Component({
  selector: 'hour4u-admin-briefing',
  templateUrl: './briefing.component.html',
  styleUrls: ['./briefing.component.scss']
})
export class BriefingComponent implements OnInit {
  id: string = '';
  agency: string = '';
  briefingFormDetails: any = null;

  constructor(
    private router: Router,
    private briefingService: BrifingFormService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id') || '';
      console.log(this.id)
      if (this.id) {
        this.briefingService.getBriefingFormById(this.id).subscribe((res) => {
          console.log(res)
          this.briefingFormDetails = res;
          this.agency = res.creatorEntity.entityMeta.name;
        });
      }
    });
  }

  continue() {
    this.router.navigateByUrl(`briefing/about/form/${this.id}`);
  }

  contactSupport() {
    window.open('https://wa.me/919560412861', '_blank');
  }
}
